export const en = {
  "profile.phone": "Phone",
  "profile.phoneInvalid": "Enter 7 to 15 digits, optionally starting with +.",
  "common.scrollableTable": "Scrollable table",
  "auth.ecpAccountLogin": "Company account login (if you have multiple accounts)",
  "layout.currentCompany": "Current company",
  "auth.accountUnavailable": "Sign-in failed. Check your credentials and account availability.",
  "documentUpload.selectSingle": "Choose a file or drag it here",
  "documentUpload.selectMultiple": "Choose files or drag them here",
  "documentUpload.requirements":
    "PDF, DOC and DOCX are supported. Maximum size per file is 20 MB.",
  "documentUpload.unsupportedType":
    "File “{name}” has an unsupported format. Choose PDF, DOC or DOCX.",
  "documentUpload.emptyFile": "File “{name}” is empty and cannot be uploaded.",
  "documentUpload.fileTooLarge":
    "File “{name}” exceeds the maximum size of 20 MB.",
  "documentUpload.uploadFailed":
    "Could not upload the file. Check its format and size.",
  // Common
  "common.yes": "Yes",
  "common.no": "No",
  "common.actions": "Actions",
  "common.copyId": "Copy full ID",
  "common.showFullId": "Show or hide full ID",
  "common.idCopied": "Full ID copied",
  "common.idCopyFailed": "Could not copy the ID. Expand it and copy it manually.",
  "common.createdAt": "Created at",
  "common.updatedAt": "Updated at",

  // ProcessUserDetails
  "process.returnForRework": "Send back for revision",
  "process.deny": "Reject",
  "process.edit": "Edit",
  "process.send": "Send",
  "process.return": "Return",
  "process.delete": "Delete",
  "process.createLinkedDocument": "Create linked document",
  "process.signed": "Signed",
  "process.signWithEcp": "Sign with EDS",
  "process.comments": "Comments",
  "process.info": "Process information",
  "process.name": "Name",
  "process.executor": "Executor",
  "process.comment": "Comment",
  "process.status": "Status",
  "process.noData": "No data",
  "process.tab.requisites": "Requisites",
  "process.tab.content": "Content",
  "process.tab.attachments": "Attachments",
  "process.tab.processes": "Processes",
  "process.tab.history": "History",
  "process.tab.accessRights": "Access rights",
  "process.tab.linkedDocuments": "Linked documents",
  "process.access.view": "View",
  "process.access.creator": "Creator",
  "process.started": "Process started",
  "process.execute": "Complete task",
  "process.signingMethod": "Signing method",
  "process.signingSessionsLoading": "Checking active signing sessions...",
  "process.signingSessionsError":
    "Could not check the active session. Refresh the page before signing.",
  "process.selectSigningMethod": "Select signing method",
  "process.ncaLayerOption": "NCALayer — EDS key on this computer",
  "process.egovMobileOption": "eGov Mobile — QR code in the mobile app",
  "process.activeMobileSession":
    "An eGov Mobile session is active. Finish it before using NCALayer.",
  "process.ncaManifestSigning": "Sign the package through NCAManifest.xml",
  "process.packageSigned": "Package signed",
  "process.waitingNcaLayer": "Waiting for NCALayer...",
  "process.signWithNcaLayer": "Sign",
  "process.ncaLayerHint":
    "Sign the document package (NCAManifest.xml) with an EDS key on this computer through NCALayer.",
  "process.egovMobileHintMobile":
    "Sign in eGov Mobile. After creating the session, tap “Open in eGov Mobile”.",
  "process.egovMobileHintDesktop":
    "Sign by scanning the QR code in the eGov Mobile app.",
  "process.openEgovMobile": "Open in eGov Mobile",
  "process.generateQrCode": "Generate QR code",
  "process.continueSigning": "Continue signing",
  "process.mobileOnlyWarning":
    "Only eGov Mobile signing is available on a mobile device",
  "process.waitNcaLayerWarning":
    "Wait for the current NCALayer signing operation to finish",
  "process.finishMobileSessionWarning":
    "Finish the active eGov Mobile session first",
  "process.mobileSessionCheckError":
    "Could not check the active signing session",
  "process.mobileSigningSuccess": "Documents signed through eGov Mobile",
  "process.manifestLoadError": "Could not load NCAManifest for signing",
  "process.ncaLayerConnectionError":
    "Could not connect to NCALayer. Make sure the application is running.",
  "process.signatureSaveError": "Could not save the signature",

  // eGov Mobile signing
  "mobileSign.title": "Sign through eGov Mobile",
  "mobileSign.creating": "Creating a signing session...",
  "mobileSign.retry": "Try again",
  "mobileSign.success":
    "Documents were signed successfully through eGov Mobile.",
  "mobileSign.scanQr":
    "Scan the QR code in eGov Mobile and confirm the signing operation.",
  "mobileSign.status": "Status",
  "mobileSign.expiresAt": "Expires at",
  "mobileSign.documents": "Documents",
  "mobileSign.openHint":
    "Tap “Open in eGov Mobile” and confirm the signing operation in the app.",
  "mobileSign.open": "Open in eGov Mobile",
  "mobileSign.checking": "Checking...",
  "mobileSign.checkStatus": "Check status",
  "mobileSign.newSession": "Create a new session",
  "mobileSign.status.created": "Session created",
  "mobileSign.status.waiting": "Waiting for a signature in eGov Mobile",
  "mobileSign.status.callback": "Signature received and being verified",
  "mobileSign.status.signed": "Documents signed",
  "mobileSign.status.failed": "Signing failed",
  "mobileSign.status.expired": "Session expired",
  "mobileSign.status.cancelled": "Signing cancelled",
  "mobileSign.cancelling": "Cancelling the eGov Mobile session...",
  "mobileSign.cancelConfirm":
    "Cancel signing through eGov Mobile? The current session will be closed.",
  "mobileSign.cancelProcessing":
    "The signature has already been received and is being processed. Wait for the operation to finish.",
  "mobileSign.cancelError": "Could not cancel the eGov Mobile session",
  "mobileSign.requestError": "The eGov Mobile request failed",

  // Document history / links
  "documentHistory.type": "Type",
  "documentHistory.status": "Status",
  "documentHistory.user": "User",
  "documentHistory.message": "Message",
  "documentHistory.dateTime": "Date and time",
  "linkedDocuments.name": "Document name",
  "linkedDocuments.action": "Action",

  // Layout / Sidebar
  "layout.logout": "Logout",
  "layout.createDocument": "Create document",
  "layout.myTasks": "My tasks",
  "layout.allDocuments": "All documents",
  "layout.allTasks": "All tasks",
  "layout.taskForRework": "For rework",
  "layout.taskForSigning": "For signing",
  "layout.taskForApproval": "For approval",
  "layout.taskForReview": "For review",
  "layout.taskForExecution": "For execution",

  // Dashboard
  "dashboard.greeting.morning": "Good morning",
  "dashboard.greeting.afternoon": "Good afternoon",
  "dashboard.greeting.evening": "Good evening",
  "dashboard.retry": "Retry",
  "dashboard.incomingDocuments": "Incoming documents",
  "dashboard.outgoingDocuments": "Outgoing documents",
  "dashboard.tasksToday": "Tasks for today",
  "dashboard.overdueTasks": "Overdue tasks",
  "dashboard.stats.total": "Total documents",
  "dashboard.stats.inProgress": "Documents in progress",
  "dashboard.stats.signed": "Signed documents",
  "dashboard.stats.rework": "Documents for rework",
  "dashboard.stats.denied": "Rejected documents",
  "dashboard.chart.noData": "No data",
  "dashboard.chart.total": "Total",
  "dashboard.tasks.viewAll": "View all",
  "dashboard.tasks.empty": "No tasks",
  "dashboard.tasks.initiator": "Initiator:",
  "dashboard.tasks.deadline": "Deadline:",
  "dashboard.tasks.viewDocument": "View document",
  "dashboard.error.loadFailed": "Failed to load dashboard data",
  "dashboard.error.generic": "Dashboard loading error",
  "dashboard.emptyValue": "—",
  "dashboard.details.openList": "Open list",
  "dashboard.details.viewDocuments": "View",
  "dashboard.details.totalFound": "Total found",
  "dashboard.details.loading": "Loading list",
  "dashboard.details.empty": "There is no data for the selected indicator yet",
  "dashboard.details.error": "Failed to load the list. Please try again.",
  "dashboard.details.document": "Document",
  "dashboard.details.categoryAndProcess": "Category / process",
  "dashboard.details.status": "Status",
  "dashboard.details.initiator": "Initiator",
  "dashboard.details.dates": "Dates",
  "dashboard.details.actions": "Actions",
  "dashboard.details.createdAt": "Created",
  "dashboard.details.openDocument": "Open document",
  "dashboard.details.open": "Open",
  "dashboard.news.title": "News and useful information",
  "dashboard.news.subtitle":
    "SmartDocs updates and important information about digital signatures",
  "dashboard.news.readMore": "Read more",
  "dashboard.news.officialSource": "Official source",
  "dashboard.news.sourceNotice":
    "The link opens the NCA of the Republic of Kazakhstan website in a new tab.",
  "dashboard.news.category.feature": "SmartDocs features",
  "dashboard.news.category.guide": "Guide",
  "dashboard.news.category.security": "Security",
  "dashboard.news.egovMobile.title":
    "eGov Mobile signing is now available in SmartDocs",
  "dashboard.news.egovMobile.summary":
    "At the signing step, select eGov Mobile: scan the QR code on a computer or open the app on your smartphone. You do not need to upload your EDS key to the computer.",
  "dashboard.news.egovMobile.details.intro":
    "This feature is available for tasks that require a digital signature. SmartDocs sends the document package to eGov Mobile and records the signing result automatically.",
  "dashboard.news.egovMobile.details.step1":
    "Open a task that requires the document to be signed.",
  "dashboard.news.egovMobile.details.step2":
    "Select eGov Mobile in the Signing method field.",
  "dashboard.news.egovMobile.details.step3":
    "On a computer, generate a QR code and scan it in eGov Mobile. On a smartphone, open the app using the provided link.",
  "dashboard.news.egovMobile.details.step4":
    "Review the information and confirm signing in the app. SmartDocs will update the task status automatically.",
  "dashboard.news.expiration.title": "Check your EDS expiry date in advance",
  "dashboard.news.expiration.summary":
    "A valid EDS can be renewed online. Once it expires, a new key must be issued.",
  "dashboard.news.expiration.details.intro":
    "An EDS can be renewed online while the current key is still valid. Check the expiry date in advance to keep document signing available.",
  "dashboard.news.expiration.details.step1":
    "Check the key expiry date in your NCA personal account.",
  "dashboard.news.expiration.details.step2":
    "Start the renewal before your current EDS expires.",
  "dashboard.news.expiration.details.step3":
    "Store the new keys on a personal secure device and set a strong password.",
  "dashboard.news.expiration.details.step4":
    "If the current key has already expired, new EDS keys must be issued.",
  "dashboard.news.security.title": "Never share your EDS key",
  "dashboard.news.security.summary":
    "Keep the key under your sole control, use a strong password, and remove keys from shared computers.",
  "dashboard.news.security.details.intro":
    "An EDS has the same legal force as a handwritten signature. The owner must retain sole control of the keys and access to them.",
  "dashboard.news.security.details.rule1":
    "Keep the keys only on a personal or protected storage device.",
  "dashboard.news.security.details.rule2":
    "Use a unique strong password and do not store it together with the key.",
  "dashboard.news.security.details.rule3":
    "Never send keys or passwords by email, messaging apps, or third-party websites.",
  "dashboard.news.security.details.rule4":
    "Remove keys from shared computers and reissue them if compromise is suspected.",

  // Auth / Login
  "auth.welcomeFull": "Welcome to the electronic document management system",
  "auth.loginWithEcp": "Login with EDS",
  "auth.or": "or",
  "auth.loginWith": "Login with",
  "auth.loginAndPassword": "login and password",
  "auth.welcomeShort": "Welcome! ",
  "auth.loginPlaceholder": "Login",
  "auth.passwordPlaceholder": "Password",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.loginButton": "Login",
  "auth.ecp": "EDS",
  "auth.ncaError": "Error connecting to NCALayer. Start NCALayer and click OK",
  "auth.chooseAccount": "Choose a work account",
  "auth.useAnotherAccount": "Sign in with another account",
  "auth.changeAccount": "Change account",
  "auth.removeAccount": "Remove saved account",
  "auth.rememberAccountTitle": "Remember this account on this device?",
  "auth.rememberAccountDescription":
    "Next time you can select this account and enter its password or use EDS.",
  "auth.rememberAccount": "Remember",
  "auth.notNow": "Not now",
  "auth.accountMismatch":
    "The selected account does not match the authenticated account. Sign in again.",
  "auth.platformAdministrator": "Platform administrator",

  "document.regNumber": "Reg. number",
  "document.category": "Document category",
  "document.createdBy": "Created",
  "document.status": "Document status",

  // Process history
  "processHistory.toggleHide": "Hide",
  "processHistory.toggleShow": "Show",
  "processHistory.reworkSuffix": "rework processes",
  "processHistory.column.process": "Process",
  "processHistory.column.status": "Status",
  "processHistory.column.executor": "Executor",
  "processHistory.column.comment": "Comment",
  "processHistory.column.deadline": "Deadline",
  "processHistory.column.start": "Start",
  "processHistory.column.end": "End",
  "processHistory.initiator": "Initiator:",
  "processHistory.signInfo": "Signature information",
  "processHistory.executedBy": "executed by",

  // Document details
  "document.edit": "Edit",
  "documentDraftBatch.title": "Bulk draft editing",
  "documentDraftBatch.select": "Select draft",
  "documentDraftBatch.open": "Edit selected",
  "documentDraftBatch.mapping": "Map files to templates",
  "documentDraftBatch.values": "Template parameters",
  "documentDraftBatch.commonValue": "Common value",
  "documentDraftBatch.individualValues": "Individual values",
  "documentDraftBatch.preview": "Preview and edit",
  "documentDraftBatch.apply": "Update drafts",
  "documentDraftBatch.noEditable":
    "Select unsent documents with New or Rework status.",
  "documentDraftBatch.legacyWarning":
    "Legacy files have no saved source parameters. Select their original templates and verify the preview before updating.",
  "documentDraftBatch.success": "Drafts updated successfully",
  "document.send": "Send",
  "document.return": "Return",
  "document.delete": "Delete",
  "document.generateArchive": "Generate archive",
  "document.downloadArchive": "Download archive",
  "document.downloadElectronicCopies": "Download electronic copies",
  "document.tab.requisites": "Document details",
  "document.tab.esedo": "ESEDO details",
  "document.tab.content": "Content",
  "document.tab.attachments": "Attached documents",
  "document.tab.processes": "Processes",
  "document.tab.history": "History",
  "document.tab.accessRights": "Access rights",
  "document.tab.linkedDocuments": "Linked documents",

  //navbar
  "navbar.home": "Home",
  "navbar.users": "Users",
  "navbar.companies": "Companies",
  "navbar.templates": "Templates",
  "navbar.categories": "Categories",
  "navbar.entityApproval": "Coordination",
  "navbar.structures": "Document structure",
  "navbar.nomenclatures": "Nomenclatures",
  "navbar.positions": "Positions",
  "navbar.processes": "Processes",
  "navbar.roles": "Roles",
  "navbar.tenantManagement": "Platform companies",
  "theme.dark": "Switch to dark theme",
  "theme.light": "Switch to light theme",
  "permission.uiDarkTheme": "Use dark theme",
  "rolePermissions.appearance": "Interface appearance",
  "navbar.logs": "Logs",
  "navbar.helpdesk": "Helpdesk",
  "navbar.myTickets": "My tickets",
  "navbar.newHelpdeskTickets": "New unassigned tickets",
  "navbar.control": "Control panel",
  "layout.sections": "Sections",
  "layout.collapseSidebar": "Collapse menu",
  "layout.expandSidebar": "Expand menu",
  "layout.closeSections": "Close sections menu",
  "navbar.documents": "My documents",
  "navbar.tasks": "My tasks",
  "navbar.reports": "Reports",
  "navbar.tracked": "Tracked",
  "navbar.favorite": "Favorite",
  "navbar.drafts": "Drafts",
  "navbar.rework": "Rework",

  // Document template form
  "docTemplate.titleEdit": "Edit template",
  "docTemplate.titleCreate": "Create template",
  "docTemplate.name": "Name",
  "docTemplate.comment": "Comment",
  "docTemplate.status": "Status",
  "docTemplate.template": "Template",
  "docTemplate.footer.enabled": "Add footer",
  "docTemplate.footer.lastPage": "Last page only",
  "docTemplate.footer.allPages": "Every page",
  "docTemplate.footer.height": "Footer area height, mm",
  "docTemplate.footer.heightError": "Enter a height from 10 to 80 mm",
  "docTemplate.footer.html": "Footer HTML",
  "docTemplate.footer.htmlError": "Enter footer HTML",
  "docTemplate.update": "Update",
  "docTemplate.create": "Create",
  "docTemplate.details.content": "Template content",
  "docTemplate.details.options": "Values",
  "docTemplate.details.pdfError": "Failed to generate PDF",

  // Document template (payload/details)
  "documentTemplate.comment": "Comment",
  "documentTemplate.template": "Template",

  // Document form
  "docForm.titleEdit": "Edit document",
  "docForm.titleCreate": "Create document",
  "docForm.category": "Category",
  "docForm.selectCategory": "Select category",
  "docForm.params": "Parameters",
  "docForm.extraOptions": "Extra Options",
  "docForm.theme": "Subject",
  "docForm.nomenclature": "Nomenclature",
  "docForm.selectNomenclature": "Select nomenclature",
  "docForm.price": "Values",
  "docForm.description": "Description",
  "docForm.uploadDocument": "Upload document",
  "docForm.selectTemplate": "Select template",
  "docForm.uploadTab": "Upload",
  "docForm.generateTab": "Generate",
  "docForm.previewTemplate": "Preview template",
  "docForm.previewFilledTemplate": "Preview with fields",
  "docForm.previewFilledTitle": "Filled template preview",
  "docForm.backToFields": "Back to fields",
  "docForm.previewConflictTitle": "Template fields have changed",
  "docForm.previewConflictMessage":
    "Field values have changed. Rebuild the document from the template? Manual text changes will be lost.",
  "docForm.previewConflictHint":
    "If you keep your current version, the new field values will not be included in the document.",
  "docForm.previewConflictKeep": "Keep my version",
  "docForm.previewConflictRebuild": "Rebuild from template",
  "docForm.editedBadge": "Edited",
  "docForm.editedDetailsTitle": "File changes",
  "docForm.changedFields": "Changed fields",
  "docForm.manualTextChanged": "The document text was edited manually",
  "docForm.emptyValue": "Not filled in",
  "docForm.leaveTitle": "Leave document creation?",
  "docForm.leaveMessage":
    "Are you sure you want to leave this page? Finish creating the document first, otherwise your progress will be lost.",
  "docForm.leaveStay": "Stay",
  "docForm.leaveConfirm": "Leave",
  "docForm.updateTemplate": "Update",
  "docForm.hideTemplate": "Hide",
  "docForm.mainFileSelectTemplate": "Select template",
  "docForm.fileName": "File name",
  "docForm.confirm": "Confirm",
  "docForm.delete": "Delete",
  "docForm.mainFile": "Main file",
  "docForm.extraFiles": "Additional files",
  "docForm.processList": "Process list",
  "docForm.deadline": "Deadline",
  "docForm.apply": "Apply",
  "docForm.cancel": "Cancel",
  "docForm.datePlaceholder": "dd/MM/yyyy",
  "docForm.executionType": "Execution type",
  "docForm.serialExecution": "Sequential execution",
  "docForm.parallelExecution": "Parallel execution",
  "docForm.process": "Process",
  "docForm.addFreeProcess": "+ Add process",
  "docForm.freeProcessHint":
    "You can add any number of free processes allowed by the selected category.",
  "docForm.executorCanDeny": "Executor can reject",
  "docForm.selectProcessType": "Select process type",
  "docForm.removeProcess": "Remove process",
  "docForm.moveUp": "Move up",
  "docForm.moveDown": "Move down",
  "docForm.name": "Name",
  "docForm.processKind": "Process kind",
  "docForm.processType": "Process type",
  "docForm.receivers": "Recipients",
  "docForm.comment": "Comment",
  "docForm.submitUpdate": "Update",
  "docForm.submitCreate": "Create",
  "docForm.fileNameRequired": "File name is required!",
  "docForm.templateRequired": "Template is required!",
  "docForm.fieldRequired": "This field is required",
  "docForm.generateAdditionalFile": "Generate additional file",

  // Sign info modal
  "signInfo.title": "Signature information",
  "signInfo.file": "File",
  "signInfo.bin": "BIN",
  "signInfo.iin": "IIN",
  "signInfo.type": "Type",
  "signInfo.serialNumber": "Certificate serial number",
  "signInfo.signDate": "Sign date",
  "signInfo.fullName": "Full name",
  "signInfo.certPeriod": "Certificate validity period",

  // Info list
  "infoList.category": "Category",
  "infoList.initiator": "Initiator",
  "infoList.theme": "Subject",
  "infoList.index": "Document index",
  "infoList.createdAt": "Created at",
  "infoList.status": "Status",

  // Profile
  "profile.title": "Personal account",
  "profile.upload": "+ Upload",
  "profile.changePhoto": "Change photo",
  "profile.uploadPhoto": "Upload photo",
  "profile.transferRights": "Transfer rights",
  "profile.changePassword": "Change password",
  "profile.changePasswordTitle": "Change password",
  "profile.refreshRole": "Refresh role",
  "profile.refreshRoleLoading": "Refreshing...",
  "profile.refreshRoleSuccess": "Role and permissions updated",
  "profile.refreshRoleError": "Could not update role and permissions",
  "profile.switchAccount": "Switch work account",
  "profile.login": "Login",
  "profile.email": "Email",
  "profile.iin": "IIN",
  "profile.name": "First name",
  "profile.surname": "Last name",
  "profile.middleName": "Middle name",
  "profile.company": "Company",
  "profile.department": "Department",
  "profile.job": "Position",
  "profile.manager": "Manager",
  "profile.roles": "Roles",
  "profile.permissions": "Permissions",
  "profile.password": "Password",
  "profile.save": "Save",
  "profile.updateSuccess": "Data successfully updated",
  "profile.updateError": "Error updating data",

  // Process template list
  "processTemplateList.title": "Process list",
  "processTemplateList.name": "Name",
  "processTemplateList.search": "Search",
  "processTemplateList.create": "Create",
  "processTemplateList.noData": "Nothing found",
  "processTemplateList.column.id": "ID",
  "processTemplateList.column.name": "Name",
  "processTemplateList.column.actionName": "Action name",
  "processTemplateList.column.type": "Type",
  "processTemplateList.column.position": "Position",
  "processTemplateList.action.edit": "Edit",
  "processTemplateList.type.active": "Active",
  "processTemplateList.type.disabled": "Disabled",
  "processTemplateList.type.system": "System",
  "processTemplateList.system.name.approval": "For approval",
  "processTemplateList.system.name.signing": "For signing",
  "processTemplateList.system.name.rework": "For revision",
  "processTemplateList.system.action.approval": "Approve",
  "processTemplateList.system.action.signing": "Sign",
  "processTemplateList.system.action.rework": "Revise",

  // Job form
  "jobForm.titleEdit": "Edit position",
  "jobForm.titleCreate": "Create position",
  "jobForm.name": "Name",
  "jobForm.status": "Status",
  "jobForm.namePlaceholder": "Name",
  "jobForm.submitUpdate": "Update position",
  "jobForm.submitCreate": "Create position",

  // Nomenclature form
  "nomenclatureForm.titleEdit": "Edit nomenclature",
  "nomenclatureForm.titleCreate": "Create nomenclature",
  "nomenclatureForm.name": "Name",
  "nomenclatureForm.index": "Index",
  "nomenclatureForm.status": "Status",
  "nomenclatureForm.namePlaceholder": "Name",
  "nomenclatureForm.submitUpdate": "Update nomenclature",
  "nomenclatureForm.submitCreate": "Create nomenclature",

  // Company list / form
  "company.title": "Company list",
  "company.create": "Create",
  "company.section.board": "Board",
  "company.name": "Name",
  "company.namePlaceholder": "Name",
  "company.indexPlaceholder": "Index",
  "company.parent": "Parent company",
  "company.index": "Index",
  "company.status": "Status",
  "company.isCompany": "Is a company",
  "company.bin": "BIN",
  "company.rootBinPlatformOnly":
    "Only the platform administrator can change the root company BIN.",
  "company.binPlaceholder": "BIN",
  "company.type": "Type",
  "company.submitUpdate": "Update company",
  "company.submitCreate": "Create company",
  "company.titleEdit": "Edit company",
  "company.titleCreate": "Create company",
  "company.filter.label": "Company access",
  "company.filter.all": "All companies",
  "company.filter.internal": "Internal only",
  "company.filter.external": "External only",
  "company.accessMode": "Access mode",
  "company.empty.title": "Select a company",
  "company.empty.description":
    "Select a company from the list to view or edit its details.",
  "company.empty.createHint":
    "To add a company, use the Create company button.",
  "company.loading": "Loading company...",
  "company.loadError": "Failed to load the company",
  "company.parentLoadError": "Failed to load the parent company list",

  // Common UI
  "common.allJobs": "All positions",
  "common.allRoles": "All roles",
  "common.allStatuses": "All statuses",
  "common.allCategories": "All categories",
  "common.allReportTypes": "All report types",
  "common.noData": "Nothing found",
  "common.fullName": "Full name",
  "common.confirm": "Confirm",
  "common.cancel": "Cancel",
  "common.clear": "Clear",
  "common.details": "Details",
  "common.edit": "Edit",
  "common.notSelected": "Not selected",
  "common.companies": "Companies",
  "common.search": "Search",
  "common.create": "Create",
  "common.name": "First name",
  "common.surname": "Last name",
  "common.status": "Status",
  "common.iin": "IIN",
  "common.job": "Position",
  "common.role": "Role",
  "common.company": "Company",
  "common.title": "Name",
  "common.placeholderName": "Name",
  "common.index": "Index",
  "common.type": "Type",
  "common.id": "ID",
  "common.save": "Save",

  // User
  "userList.title": "User list",
  "userForm.titleEdit": "Edit",
  "userForm.titleCreate": "Create",
  "userForm.user": "user",
  "userForm.iinError": "Enter a valid IIN",
  "userForm.userStatus": "User status:",
  "userForm.save": "Save",
  "userDetails.title": "User information",
  "userDetails.delete": "Delete",

  // Transfer authority
  "transferAuthority.title": "Transferred rights list",
  "transferAuthority.menuTitle": "Substitution",
  "transferAuthority.rightsType": "Rights type",
  "transferAuthority.create": "+ Create",
  "transferAuthority.reason": "Reason",
  "transferAuthority.transferReason": "Transfer reason",
  "transferAuthority.closeReason": "Close reason",
  "transferAuthority.startDate": "Start date",
  "transferAuthority.endDate": "End date",
  "transferAuthority.transferredRights": "Transferred rights",
  "transferAuthority.receivedRights": "Received rights",
  "transferAuthority.full": "Full",
  "transferAuthority.partial": "Partial",
  "transferAuthority.closed": "Closed",
  "transferAuthority.waiting": "Waiting",
  "transferAuthority.active": "Active",
  "transferAuthority.denied": "Denied",
  "transferAuthority.createModalTitle": "Create rights transfer",
  "transferAuthority.selectUser": "Select user",
  "transferAuthority.startDateLabel": "Start date",
  "transferAuthority.endDateLabel": "End date",
  "transferAuthority.invalidDate": "Invalid date",
  "transferAuthority.createSuccess": "Rights transfer request created",
  "transferAuthority.createError": "Failed to create rights transfer",
  "transferAuthority.loadError": "Failed to load rights transfer list",
  "transferAuthority.confirmSuccess": "Rights transfer confirmed",
  "transferAuthority.confirmError": "Failed to confirm rights transfer",
  "transferAuthority.denySuccess": "Rights transfer denied",
  "transferAuthority.denyError": "Failed to deny rights transfer",

  "profile.entityApproval": "Coordination",

  // Entity approval
  "entityApproval.title": "Approval queue",
  "entityApproval.entityType": "Entity type",
  "entityApproval.actionType": "Action",
  "entityApproval.entityId": "Entity ID",
  "entityApproval.requesterId": "Requester (ID)",
  "entityApproval.requester": "Author",
  "entityApproval.coordinatorId": "Coordinator",
  "entityApproval.payload": "Request payload",
  "entityApproval.payloadCategory": "Document category",
  "entityApproval.approvalStatus": "Approval status",
  "entityApproval.constructor.mainInfo": "Main information",
  "entityApproval.template.mainInfo": "Main information",
  "entityApproval.user.mainInfo": "Main information",
  "entityApproval.user.security": "Security",
  "entityApproval.company.mainInfo": "Main information",
  "entityApproval.approve": "Approve",
  "entityApproval.reject": "Reject",
  "entityApproval.detailsTitle": "Approval request",
  "entityApproval.requestInfo": "Request information",
  "entityApproval.rejectTitle": "Reject request",
  "entityApproval.rejectReason": "Rejection reason",
  "entityApproval.approveSuccess": "Request approved",
  "entityApproval.approveError": "Failed to approve request",
  "entityApproval.rejectSuccess": "Request rejected",
  "entityApproval.rejectError": "Failed to reject request",
  "entityApproval.backToList": "Back to coordination",
  "entityApproval.loading": "Loading approval request...",
  "entityApproval.loadError": "Failed to load the approval request",
  "entityApproval.type.documentConstructor": "Document category",
  "entityApproval.type.documentTemplate": "Document template",
  "entityApproval.type.company": "Company",
  "entityApproval.type.user": "User",
  "entityApproval.action.create": "Create",
  "entityApproval.action.update": "Update",
  "entityApproval.action.deactivate": "Deactivate",
  "entityApproval.status.waiting": "Pending",
  "entityApproval.status.approved": "Approved",
  "entityApproval.status.rejected": "Rejected",
  "entityApproval.entityStatus.waiting": "Pending approval",
  "entityApproval.entityStatus.active": "Active",
  "entityApproval.entityStatus.deactivated": "Deactivated",

  // Deactivate entity
  "deactivate.title": "Deactivation",
  "deactivate.confirm":
    "A deactivation approval request will be created. Continue?",
  "deactivate.coordinator": "Coordinator (optional)",
  "deactivate.coordinatorNotSet": "Not assigned",
  "deactivate.submit": "Submit for approval",
  "deactivate.success": "Deactivation request submitted",
  "deactivate.error": "Failed to submit request",
  "approval.submitted": "Request submitted for approval",
  "approval.submitError": "Failed to submit approval request",
  "approval.pending": "Pending approval",
  "approval.viewRequest": "View approval request",

  "esedo.title": "ESEDO",
  "esedo.enabled": "Enable ESEDO attributes",
  "esedo.documentType": "ESEDO document type",
  "esedo.questionNature": "Question nature",
  "esedo.counterpartyMode": "Counterparty selection mode",
  "esedo.modeNotUsed": "Not used",
  "esedo.modeOptional": "Optional",
  "esedo.modeRequired": "Required",
  "esedo.partners": "ESEDO partners",
  "esedo.selectPartners": "Select partners",
  "esedo.partnersRequired": "At least one ESEDO partner is required",

  "entityScope.title": "Visibility and approval",
  "entityScope.hint":
    "Changes apply after coordinator approval. Directorate is set automatically.",
  "entityScope.viewScope": "Who can view",
  "entityScope.editScope": "Who can edit",
  "entityScope.viewDirectorates": "View directorates",
  "entityScope.editDirectorates": "Edit directorates",
  "entityScope.directorate": "Directorate",
  "entityScope.selectDirectorates": "Select directorates",
  "entityScope.coordinator": "Approval coordinator",
  "entityScope.coordinatorAny": "Any directorate coordinator",
  "entityScope.coordinatorHint":
    "If not set, any coordinator from your directorate can process the request",
  "entityScope.private": "Creator only",
  "entityScope.unit": "Directorate",
  "entityScope.multiUnit": "Multiple directorates",
  "entityScope.all": "Everyone",

  "company.authEnabled": "Internal access (SaaS)",
  "company.externalSigning": "External counterparty (signing only)",
  "userForm.userType": "User type",
  "userForm.userTypeInternal": "Internal",
  "userForm.userTypeExternal": "External",

  // Role
  "roleList.title": "Role list",
  "roleForm.role": "role",
  "roleForm.systemConfig": "System configuration",
  "roleForm.viewLogs": "View logs",
  "roleForm.documentConfig": "Document configuration",
  "roleForm.viewDocument": "View document",
  "roleForm.editRole": "Edit role",
  "roleForm.createRole": "Create role",
  "roleForm.nomenclature": "Nomenclature",
  "roleForm.processes": "Processes",
  "roleForm.constructor": "Constructor",
  "roleForm.template": "Template",
  "roleForm.user": "User",
  "roleForm.permissions": "Permissions",
  "roleDetails.title": "Role information",
  "roleDetails.userCount": "Number of users",
  "permission.helpdeskManage": "Manage Helpdesk tickets",

  // Logs
  "logs.title": "Logs",
  "logs.dateFrom": "Date from",
  "logs.dateTo": "Date to",
  "logs.apply": "Apply",
  "logs.cancel": "Cancel",
  "logs.datePlaceholder": "dd/MM/yyyy",
  "logs.user": "User",
  "logs.userPublicId": "User public ID",
  "logs.url": "URL",
  "logs.message": "Message",
  "logs.createdAt": "Created at",
  "logs.pageSize": "Rows per page",
  "logs.export": "Export table",
  "logs.exportError": "Could not export logs",
  "logs.status.success": "Completed",
  "logs.status.error": "Error",

  // Job
  "jobList.title": "Position list",
  "jobDetails.title": "Position information",

  // Process users / documents
  "processUsersList.searchByDocName": "Search by document name",
  "processUsersList.documentCategory": "Document category",
  "processUsersList.documentNumber": "Document number",
  "processUsersList.documentCreator": "Document creator",
  "processUsersList.extendedFilters": "Extended filters",
  "processUsersList.themePlaceholder": "Subject",
  "processUsersList.myProcesses": "My processes",
  "processUsersList.createdFrom": "Created from",
  "processUsersList.createdTo": "Created to",
  "processTemplateForm.titleEdit": "Edit process",
  "processTemplateForm.titleCreate": "Create process",
  "processTemplateForm.processName": "Process name",
  "processTemplateForm.actionName": "Action name",
  "processTemplateForm.position": "Position",
  "processTemplateForm.language.ru": "Russian",
  "processTemplateForm.language.en": "English",
  "processTemplateForm.language.kz": "Kazakh",
  "processTable.process": "Process",
  "processTable.deadline": "Deadline",
  "processTable.start": "Start",
  "processTable.end": "End",

  // Nomenclature
  "nomenclatureList.title": "Nomenclature list",
  "nomenclatureList.upload": "Upload",
  "nomenclatureList.ordNumber": "Ord. no.",
  "nomenclatureList.indOrdNumber": "Ind. ord. no.",
  "nomenclatureDetails.title": "Nomenclature information",
  "nomenclatureForm.submitUpdateShort": "Update",
  "nomenclatureForm.submitCreateShort": "Create",

  // Document template
  "docTemplateList.title": "Template list",

  // Document constructor
  "docConstructorList.title": "Category list",
  "docConstructorList.description": "Description",
  "docConstructorList.processCount": "Processes",
  "docConstructorList.access": "Access (view / edit)",
  "docConstructorList.lastUpdated": "Last updated",
  "docConstructorView.title": "View category",
  "docConstructorView.loading": "Loading…",
  "docConstructorView.backToList": "Back to categories",
  "docConstructorView.categoryId": "Category ID",
  "docConstructorView.approvalStatus": "Approval status",
  "docConstructorView.processCount": "Number of processes",
  "docConstructorView.deadlineDays": "Deadline, days",
  "docConstructorView.parallelExecution": "Parallel execution",
  "docConstructorView.allowedTemplates": "Allowed process template IDs",
  "docConstructorView.templateId": "Process template",
  "docConstructorView.price": "Amount",
  "docConstructorForm.titleEdit": "Edit category",
  "docConstructorForm.titleCreate": "Create category",
  "docConstructorForm.name": "Name",
  "docConstructorForm.subject": "Subject",
  "docConstructorForm.nomenclature": "Nomenclature",
  "docConstructorForm.description": "Description",
  "docConstructorForm.descriptionPlaceholder": "Description",
  "docConstructorForm.active": "Active",
  "docConstructorForm.disable": "Disabled",
  "docConstructorForm.params": "Parameters",
  "docConstructorForm.paramDescription": "Description",
  "docConstructorForm.paramPrice": "Value",
  "docConstructorForm.filled": "Filled",
  "docConstructorForm.mainFile": "Main file",
  "docConstructorForm.extraFiles": "Additional files",
  "docConstructorForm.process": "Process",
  "docConstructorForm.processPlaceholder": "Select a process",
  "docConstructorForm.processRequired": "Select a process for each step",
  "docConstructorForm.freeProcess": "Free process at document creation",
  "docConstructorForm.freeProcessHint":
    "Receivers, execution order, and the specific step type for a free process are selected when the document is created.",
  "docConstructorForm.processKind": "Process kind",
  "docConstructorForm.processKindTemplate": "From template",
  "docConstructorForm.processKindRequired": "Mandatory",
  "docConstructorForm.processKindFree": "Free",
  "docConstructorForm.stepTypes": "Allowed step types",
  "docConstructorForm.processType": "Process type",
  "docConstructorForm.processTypeApproval": "Approval",
  "docConstructorForm.processTypeSigning": "Signing",
  "docConstructorForm.processTypeReview": "Review",
  "docConstructorForm.processTypeExecution": "Execution",
  "docConstructorForm.filling": "Filling",
  "docConstructorForm.signEcp": "Sign with EDS",
  "docConstructorForm.parallelExecution": "Allow parallel execution",
  "docConstructorForm.receiverType": "Receiver type",
  "docConstructorForm.receiverUser": "User",
  "docConstructorForm.receiverStructure": "Company",
  "docConstructorForm.filterType": "Filter type",
  "docConstructorForm.sameOrigin": "User department",
  "docConstructorForm.allCompanies": "All companies",
  "docConstructorForm.individualCompany": "Individual company selection",
  "docConstructorForm.creatorCompany": "Initiator company",
  "docConstructorForm.departmentWithChildren":
    "Department with child departments",
  "docConstructorForm.companies": "Companies",
  "docConstructorForm.role": "Role",
  "docConstructorForm.users": "Users",
  "docConstructorForm.job": "Positions",
  "docConstructorForm.rework": "Revision",
  "docConstructorForm.deny": "Reject",
  "docConstructorForm.answer": "Reply",
  "docConstructorForm.review": "Review",
  "docConstructorForm.transfer": "Transfer",
  "docConstructorForm.filteringType": "Filtering type",
  "docConstructorForm.addProcess": "+ Add process",
  "docConstructorForm.needProcesses": "Processes must be added",
  "docConstructorForm.receiverTypeRequired": "Receiver type cannot be empty",
  "docConstructorForm.update": "Update",
  "docConstructorForm.create": "Create",

  // Document list
  "documentList.myDocuments": "My documents",
  "documentList.documentStatus": "Document status",
  "documentList.foundDocuments.one": "Found {count} document",
  "documentList.foundDocuments.few": "Found {count} documents",
  "documentList.foundDocuments.many": "Found {count} documents",

  "documentList.shownRange": "Showing documents {from}–{to} of {total}",
  "documentList.noDocuments": "No documents found",
  "pagination.navigation": "Pagination",
  "pagination.firstPage": "First page",
  "pagination.previousPage": "Previous page",
  "pagination.page": "Page",
  "pagination.nextPage": "Next page",
  "pagination.lastPage": "Last page",

  // Company
  "companyDetails.title": "Company structure",
  "companyDetails.departments": "Departments",
  "companyDetails.selectCompany": "Select company",
  "companyDetails.branchName": "Branch name",
  "companyDetails.counteragentEsedo": "ESEDO counterparty",
  "companyDetails.index": "Index",
  "companyDetails.bin": "BIN",
  "companyDetails.position": "Position",
  "companyDetails.personType": "Person type",
  "companyDetails.personTypeLegal": "Legal entity",
  "companyDetails.personTypeIndividual": "Individual",
  "companyDetails.isCompany": "Is a company",
  "companyList.title": "Company list",
  "companyList.board": "Board",

  // Reports
  "reports.title": "Reports",
  "reports.theme": "Subject",
  "reports.authorName": "Author name",
  "reports.regNumber": "Registration number",
  "reports.dateEnd": "Date to",
  "reports.name": "Name",
  "reports.saveReport": "Save report",
  "reports.save": "Save",
  "reports.savedReports": "Saved reports",
  "reports.reportFiles": "Report files",
  "reports.excelExport": "Export to Excel",
  "reports.category": "Category",
  "reports.nomenclature": "Nomenclature",
  "reports.description": "Description",
  "reports.value": "Value",
  "reports.status": "Status",
  "reports.documentReportTab": "Document report",
  "reports.systemReportTab": "System reports",
  "reports.reportTypeFilter": "Report type",
  "reports.documentCategory": "Document category",
  "reports.subCategory": "Subcategory",
  "reports.createdAtStart": "Created from",
  "reports.createdAtEnd": "Created to",
  "reports.finishedAtStart": "Finished from",
  "reports.finishedAtEnd": "Finished to",
  "reports.typeCompletedOnTime": "Completed on time",
  "reports.typeOverdue": "Overdue",
  "reports.typeInProgress": "In progress / new",
  "reports.typeRejected": "Rejected",
  "reports.columnId": "ID",
  "reports.columnDocumentNumber": "Document number",
  "reports.columnCreatorFullName": "Initiator",
  "reports.columnSubCategoryName": "Subcategory",
  "reports.columnReceiversNames": "Counterparties",
  "reports.columnSubdivisionName": "Subdivision",
  "reports.columnEsedoSenderName": "ESEDO sender",
  "reports.columnIncomingNumber": "Incoming number",
  "reports.columnOutgoingNumber": "Outgoing number",
  "reports.columnExecutors": "Executor",
  "reports.columnDeadline": "Deadline",
  "reports.columnFinishedAt": "Finished at",
  "reports.saveTemplateTitle": "Save template",
  "reports.templateType": "Template type",
  "reports.exportSuccess": "Report exported successfully",
  "reports.exportError": "Failed to export report",
  "reports.templateSaved": "Template saved",
  "reports.templateDeleted": "Template deleted",
  "reports.deleteTemplateConfirm": "Are you sure you want to delete?",
  "reports.systemReportType": "System report type",
  "reports.timeType": "Time type",
  "reports.timeTypeCreated": "By creation date",
  "reports.timeTypeFinished": "By completion date",
  "reports.companies": "Companies",
  "reports.processType": "Process type",
  "reports.roles": "User roles",
  "reports.isSigning": "Signing",
  "reports.sewsType": "ESEDO type",
  "reports.preview": "Preview",
  "reports.previewError": "Failed to load preview",
  "reports.previewFromTemplate": "Preview from template",
  "reports.exportFromTemplate": "Export from template",

  "archive.title": "Document structure",
  "archive.createDocument": "Create Document",
  "archive.createFolder": "Create Folder",
  "archive.move": "Move",
  "archive.delete": "Delete",
  "archive.root": "Root",
  "archive.regNumber": "Case number",
  "archive.type": "Type",
  "archive.date": "Date",
  "archive.folder": "Folder",
  "archive.document": "Document",
  "archive.open": "Open",
  "archive.folderAccess": "Folder access",
  "archive.currentAccess": "Current access",
  "archive.grantAccess": "Grant access to users",
  "archive.grantAccessSubmit": "Grant access",
  "archive.moveHint": "Select destination folder",
  "archive.moveTarget": "Destination",
  "archive.noFolders": "No subfolders",
  "archive.downloadFolder": "Download folder",
  "archive.deleteFolderConfirm": "Delete selected folder(s)?",
  "archive.deleteSuccess": "Deleted successfully",
  "archive.loading": "Loading...",

  "common.close": "Close",
  "common.delete": "Delete",
  "common.error": "An error occurred",

  "sign.sign": "Sign",
  "sign.rework": "Send for rework",
  "sign.deny": "Reject",
  "sign.success": "Document successfully signed",
  "sign.denied": "Document rejected",
  "sign.reworked": "Sent for rework",

  "sign.number": "No.",
  "sign.description": "Description",
  "sign.expiresAt": "Expiration date",
  "sign.recipient": "Recipient",
  "sign.recipientIinBin": "Recipient IIN/BIN",
  "sign.status": "Status",
  "sign.deniedComment": "Rejection reason",

  "sign.tabs.documentDetails": "Document details",
  "sign.tabs.attachedFiles": "Attached files",

  "sign.actions.downloadFile": "Download file",
  "sign.actions.viewFile": "View file",

  "sign.enter_comment": "Enter a comment",

  "notification.title": "Notification list",
  "notification.markRead": "Mark as read",
  "notification.selectAll": "Select all",
  "process.startedAt": "Execution start date",
  "process.finishedAt": "Execution end date",
  "process.actualExecutor": "Actual executor",
  "process.onBehalfOf": "on behalf of",
  "common.noAccessToEdit": "You do not have permission to edit this section",
  "common.apply": "Apply",
  "profile.roleDetails": "Role details",
  "roleForm.adGroup": "AD group",
  "roleForm.adGroupPlaceholder": "For example, EDMS_COORDINATORS",
  "fileTable.owner": "Owner",
  "fileTable.fileName": "File name",
  "fileTable.content": "Content",
  "fileTable.description": "Description",
  "fileTable.uploadedAt": "Upload date",
  "fileTable.file": "File",
  "fileTable.downloadFile": "Download file",
  "fileTable.showDocument": "Show document",
  "documentAccess.grantCoEditor": "Grant co-editor access",
  "permission.documentAccessCoEditorGrant": "Grant co-editor access",
  "fileTable.previewUnavailable": "Preview unavailable",
  "pdfViewer.loading": "Loading document...",
  "pdfViewer.loadError": "Failed to open the PDF document",
  "pdfViewer.unsupported": "The received file is not a PDF document",
  "pdfViewer.pageError": "Failed to render the page",
  "pdfViewer.page": "Page",
  "pdfViewer.of": "of",
  "pdfViewer.firstPage": "First page",
  "pdfViewer.previousPage": "Previous page",
  "pdfViewer.nextPage": "Next page",
  "pdfViewer.lastPage": "Last page",
  "documentAccess.grantAccess": "Grant access",
  "documentAccess.user": "User",
  "documentAccess.accessType": "Access type",
  "documentAccess.action": "Action",
  "documentAccess.selectUser": "Select user",
  "documentAccess.view": "View",
  "documentAccess.creator": "Creator",
  "documentAccess.coEditor": "Co-editor",
  "permission.entityApprovalCoordinate": "Approval coordinator",
  "permission.documentConstructorCreate": "Create document categories",
  "permission.documentConstructorEdit": "Edit document categories",
  "permission.documentConstructorDeactivate": "Deactivate document categories",
  "permission.documentTemplateCreate": "Create document templates",
  "permission.documentTemplateEdit": "Edit document templates",
  "permission.documentTemplateDeactivate": "Deactivate document templates",
  "permission.documentBatchCreate": "Create documents in bulk",
  "permission.companyCreate": "Create companies",
  "permission.companyEdit": "Edit companies",
  "permission.companyDeactivate": "Deactivate companies",
  "permission.userCreate": "Create users",
  "permission.userEdit": "Edit users",
  "permission.userDeactivate": "Deactivate users",
  "permission.userViewTenant": "View users across the company",
  "permission.userEditTenant": "Edit users across the company",
  "permission.reportCreate": "Create reports",
  "permission.reportEdit": "Edit reports",
  "status.active": "Active",
  "status.disabled": "Disabled",
  "status.document.new": "New",
  "status.document.process": "In progress",
  "status.document.rework": "For revision",
  "status.document.success": "Completed",
  "status.document.denied": "Rejected",
  "status.document.deleted": "Deleted",
  "status.process.active": "Active",
  "status.process.wait": "Waiting",
  "status.process.success": "Completed",
  "status.process.denied": "Rejected",
  "status.process.cancelled": "Cancelled",
  "docTemplate.manualFields.title": "Manual fields",
  "docTemplate.manualFields.subtitle":
    "Values entered while creating a document will replace matching tags in the template.",
  "docTemplate.manualFields.addField": "Add field",
  "docTemplate.manualFields.fieldName": "Field name",
  "docTemplate.manualFields.tag": "Tag in template",
  "docTemplate.manualFields.fieldType": "Field type",
  "docTemplate.manualFields.required": "Required",
  "docTemplate.manualFields.delimiter": "Delimiter",
  "docTemplate.manualFields.outputFormat": "Output format",
  "docTemplate.manualFields.options": "Options",
  "docTemplate.manualFields.addOption": "Add option",
  "docTemplate.manualFields.optionText": "Text",
  "docTemplate.manualFields.optionValue": "Value",
  "docTemplate.manualFields.sameAsText": "Same as text",
  "docTemplate.manualFields.removeOption": "Remove",
  "docTemplate.manualFields.removeField": "Remove field",
  "docTemplate.manualFields.optionHint":
    "If value is empty, option text will be used as value.",
  "docTemplate.manualFieldType.textarea": "Multiline text",
  "docTemplate.manualFieldType.date": "Date",
  "docTemplate.manualFieldType.datetime": "Date and time",
  "docTemplate.manualFieldType.select": "Single choice",
  "docTemplate.manualFieldType.multiSelect": "Multiple choice",
  "common.back": "Back",
  "common.next": "Next",
  "common.loading": "Loading...",
  "tenantManagement.title": "Company management",
  "tenantManagement.description":
    "Create independent companies and their first administrators.",
  "tenantManagement.create": "Add company",
  "tenantManagement.editTitle": "Edit company",
  "tenantManagement.companyName": "Company name",
  "tenantManagement.bin": "BIN",
  "tenantManagement.adminSurname": "Administrator surname",
  "tenantManagement.adminName": "Administrator name",
  "tenantManagement.adminMiddleName": "Administrator middle name",
  "tenantManagement.iin": "Administrator IIN",
  "tenantManagement.login": "Administrator login",
  "tenantManagement.email": "Administrator email",
  "tenantManagement.password": "Initial password",
  "tenantManagement.rootCompany": "Root organization",
  "tenantManagement.disable": "Disable",
  "tenantManagement.disableConfirm":
    "Disable this company? Its users will lose access to the system.",
  "tenantManagement.activate": "Activate",
  "tenantManagement.loadError": "Could not load companies.",
  "tenantManagement.createSuccess": "Company created.",
  "tenantManagement.createError": "Could not create company.",
  "tenantManagement.updateSuccess": "Company details updated.",
  "tenantManagement.updateError": "Could not update company details.",
  "tenantManagement.statusSuccess": "Company status updated.",
  "tenantManagement.statusError": "Could not update company status.",
  "tenantManagement.logo": "Company logo",
  "tenantManagement.logoHelp": "PNG, JPEG, or WebP up to 1 MB.",
  "tenantManagement.uploadLogo": "Upload logo",
  "tenantManagement.deleteLogo": "Delete logo",
  "tenantManagement.deleteLogoConfirm": "Delete the company logo?",
  "tenantManagement.logoInvalid":
    "Choose a PNG, JPEG, or WebP image up to 1 MB.",
  "tenantManagement.logoUpdated": "Company logo updated.",
  "tenantManagement.logoUpdateError": "Could not update the company logo.",
  "tenantManagement.logoDeleted": "Company logo deleted.",
  "tenantManagement.logoDeleteError": "Could not delete the company logo.",
  "documentBatch.open": "Bulk creation",
  "documentBatch.title": "Bulk document creation",
  "documentBatch.subtitle":
    "Create a separate document for every selected employee and template.",
  "documentBatch.step1": "Setup",
  "documentBatch.step2": "Data entry",
  "documentBatch.step3": "Review and create",
  "documentBatch.name": "Operation name",
  "documentBatch.deadline": "Process deadline",
  "documentBatch.category": "Category",
  "documentBatch.nomenclature": "Nomenclature",
  "documentBatch.description": "Description",
  "documentBatch.price": "Amount",
  "documentBatch.processes": "Processes",
  "documentBatch.processHint":
    "For each process, choose whether its executor is the current employee or the executors configured in the category.",
  "documentBatch.freeProcesses": "Free processes",
  "documentBatch.selectFreeProcesses": "Select process types",
  "documentBatch.freeProcessesHint":
    "The selected processes and execution mode will be the same for every document in the operation.",
  "documentBatch.requiredProcess": "Required process",
  "documentBatch.selectedEmployee": "Selected employee",
  "documentBatch.categoryExecutors": "Executors from category settings",
  "documentBatch.noProcesses": "No processes are configured for this category.",
  "documentBatch.documentSource": "Document source",
  "documentBatch.templates": "Templates",
  "documentBatch.selectTemplates": "Select one or more templates",
  "documentBatch.templatesSelected": "Templates selected: {count}",
  "documentBatch.mainTemplate": "Main file template",
  "documentBatch.selectMainTemplate": "Select the main file template",
  "documentBatch.mainTemplateHint":
    "The main file defines the title and card of the created document.",
  "documentBatch.additionalTemplates": "Additional file templates",
  "documentBatch.selectAdditionalTemplates":
    "Select one or more additional templates",
  "documentBatch.additionalTemplatesSelected":
    "Additional templates selected: {count}",
  "documentBatch.packageModeHint":
    "One document with a main file and additional files will be created for each employee.",
  "documentBatch.employees": "Employees",
  "documentBatch.selectEmployees": "Select employees",
  "documentBatch.employeesSelected": "Employees selected: {count}",
  "documentBatch.sendImmediately":
    "Send documents to the process immediately after creation",
  "documentBatch.sendImmediatelyHint":
    "The system will validate all data again before starting. Clear this option to keep the documents as drafts.",
  "documentBatch.totalDocuments": "Documents to create",
  "documentBatch.totalFiles": "Files to create",
  "documentBatch.fieldScopes": "Shared and individual values",
  "documentBatch.fieldScopesHint":
    "Enter a shared value once, or edit an individual value separately for every employee.",
  "documentBatch.commonValue": "Shared value",
  "documentBatch.individualValue": "Individual value",
  "documentBatch.commonFields": "Shared fields",
  "documentBatch.individualFields": "Individual fields",
  "documentBatch.profileHint":
    "Name, IIN and job title are prefilled from the profile for this operation only. Review and edit them if necessary.",
  "documentBatch.employee": "Employee",
  "documentBatch.documentNames": "Document names",
  "documentBatch.documentNamesHint":
    "Available variables: {{template_name}}, {{full_name}} and {{iin}}.",
  "documentBatch.fileNames": "Document and file names",
  "documentBatch.fileNamesHint":
    "The main file name becomes the document title. Additional templates define file names. Available variables: {{template_name}}, {{full_name}} and {{iin}}.",
  "documentBatch.mainFile": "Main file",
  "documentBatch.additionalFile": "Additional file",
  "documentBatch.additionalFiles": "Additional files",
  "documentBatch.uploadedFiles": "Uploaded files",
  "documentBatch.uploadedFilesHint":
    "Uploaded files will be added to the document without changes.",
  "documentBatch.fileUploadError": "Could not upload the file.",
  "documentBatch.previewDocuments": "Document preview",
  "documentBatch.previewHint":
    "Select an employee and review every template with the shared and individual values applied.",
  "documentBatch.previewEmployee": "Employee to preview",
  "documentBatch.previewEmployeeRequired": "Select an employee to preview.",
  "documentBatch.review": "Operation review",
  "documentBatch.mode": "Mode",
  "documentBatch.creationFormat": "Creation format",
  "documentBatch.packageFormat": "One document with additional files",
  "documentBatch.separateFormat": "Separate documents",
  "documentBatch.sendMode": "Create and send",
  "documentBatch.draftMode": "Create drafts",
  "documentBatch.progress": "Creation progress",
  "documentBatch.successful": "Successful",
  "documentBatch.failed": "Failed",
  "documentBatch.retryFailed": "Retry failed documents",
  "documentBatch.completed": "All documents were created successfully.",
  "documentBatch.create": "Create documents",
  "documentBatch.toDocuments": "Go to documents",
  "documentBatch.defaultName": "Bulk creation",
  "documentBatch.loadError": "Could not load bulk creation data.",
  "documentBatch.categoryLoadError":
    "Could not load the category configuration.",
  "documentBatch.usersLoadError": "Could not load employees.",
  "documentBatch.requiredConfiguration":
    "Fill in the name, category, nomenclature and process deadline.",
  "documentBatch.requiredSelections":
    "Select at least one employee and one template.",
  "documentBatch.documentSourceRequired":
    "Select at least one template or upload a file.",
  "documentBatch.mainSourceRequired":
    "Select a main file template or upload a main file.",
  "documentBatch.additionalSourceRequired":
    "Select at least one template or upload an additional file.",
  "documentBatch.packageTemplatesRequired":
    "Select a main file template and at least one additional file template.",
  "documentBatch.targetProcessRequired":
    "At least one process must be assigned to the selected employee.",
  "documentBatch.limitExceeded":
    "No more than 500 documents can be created in one operation.",
  "documentBatch.fileLimitExceeded":
    "No more than 500 files can be generated in one operation.",
  "documentBatch.deadlinePast": "The process deadline cannot be in the past.",
  "documentBatch.resetFieldsConfirm":
    "The setup has changed. The data entered in step 2 will be cleared. Continue?",
  "documentBatch.subFileUnsupported":
    "The selected category requires an additional file. Choose a category without a required additional file for bulk creation.",
  "documentBatch.packageCategoryUnsupported":
    "The selected category does not support main and additional files.",
  "documentBatch.descriptionRequired":
    "A description is required for the selected category.",
  "documentBatch.priceRequired":
    "An amount is required for the selected category.",
  "documentBatch.esedoUnsupported":
    "The selected category requires individual ESEDO data and cannot be used for this bulk operation.",
  "documentBatch.prepareError": "Could not prepare bulk operation fields.",
  "documentBatch.profileMismatch":
    "Available profile data could not be loaded for every selected employee.",
  "documentBatch.fillField": "fill in the field",
  "documentBatch.invalidFields": "check fields:",
  "documentBatch.unresolvedTags":
    "the template still contains unresolved tags:",
  "documentBatch.invalidTitle": "check the document name pattern.",
  "documentBatch.titleTooLong":
    "the generated document name must not exceed 500 characters.",
  "documentBatch.probationDatesInvalid":
    "the probation end date is earlier than the start date.",
  "documentBatch.contractDatesInvalid":
    "the contract end date is earlier than the work start date.",
  "documentBatch.startError": "Could not start bulk creation.",
  "documentBatch.itemError": "Could not create the document.",
  "permission.hrView": "HR: view employee files",
  "permission.hrEmployeeEdit": "HR: manage employees",
  "permission.hrDocumentManage": "HR: manage employee documents",
  "permission.hrSettingsManage": "HR: configure document requirements",
  "permission.hrAssistantEmployeeSearch": "HR chatbot: search employees",
  "permission.hrAssistantEmployeeView": "HR chatbot: select and view employees",
  "permission.hrAssistantDocumentSearch": "HR chatbot: search documents",
  "permission.hrAssistantDocumentView": "HR chatbot: view document details",
  "permission.hrAssistantFileView": "HR chatbot: open document files",
  "hr.assistantAccessTitle": "HR chatbot access",
  "hr.assistantUnclassifiedDocuments": "Allow access to unclassified files",
  "hr.assistantUnclassifiedHint":
    "Disabled by default. The role scope and permissions to search, view and open files still apply. Files with an assigned category also require that category to be allowed.",
  "hr.assistantAccessHint":
    "Settings restrict each role in the current tenant. Both the role permission and data scope must allow an action.",
  "hr.assistantRole": "Role",
  "hr.assistantChooseRole": "Select a role",
  "hr.assistantEnabled": "Allow HR search in the chatbot for this role",
  "hr.assistantRolePermissions": "Allowed role actions",
  "hr.assistantNoPermissions":
    "This role has no chatbot permissions. Assign the required permissions in role settings.",
  "hr.assistantEmployeeScope": "Accessible employees",
  "hr.assistantScopeSelf": "Own documents only",
  "hr.assistantScopeCompany": "Employees of the same organization",
  "hr.assistantScopeSelected": "Selected employees only",
  "hr.assistantScopeTenant": "All employees in the current SaaS company",
  "hr.assistantEmployeeSearch": "Find and add an employee",
  "hr.assistantDocumentTypes": "Accessible document categories",
  "hr.assistantSelectAllDocumentTypes": "Select all categories",
  "hr.assistantDocumentTypesHint":
    "If none are selected, no documents are available through the chatbot.",
  "hr.assistantAccessLoadError": "Could not load chatbot access settings.",
  "hr.assistantAccessSaveError": "Could not save chatbot access settings.",
  "hr.employees": "Employees",
  "hr.employeesHint": "Employee files and document completeness",
  "hr.module": "HR module",
  "hr.selectAllEmployees":
    "Select all active employees in this section matching the current filters",
  "documentList.loadError":
    "Could not load the list. Please try searching again.",
  "rolePermissions.companies": "Companies",
  "rolePermissions.users": "Users",
  "rolePermissions.categories": "Document categories",
  "rolePermissions.documents": "Documents and templates",
  "rolePermissions.coordination": "Coordination",
  "rolePermissions.reports": "Reports",
  "rolePermissions.hr": "HR module",
  "rolePermissions.assistant": "HR chatbot",
  "rolePermissions.helpdesk": "Helpdesk",
  "rolePermissions.enbek": "Enbek",
  "rolePermissions.other": "Other permissions",
  "hr.settings": "HR settings",
  "hr.allMatchingSelected":
    "All available active employees matching the current filters are selected",
  "hr.employeeTypeUnavailable":
    "The employment type is not configured for this HR section",
  "hr.bulkPartial":
    "The operation was partially completed for {count} employees. Confirm again to continue with the remaining employees.",
  "hr.documentTypes": "Document requirements",
  "hr.esignLink": "eSign linking",
  "hr.allowEsignLink": "Allow linking a completed eSign document",
  "hr.esignLinkHint":
    "Allows selecting a completed eSign document instead of uploading a file. This is permission, not an indication that a document is attached.",
  "hr.documentTypesHint": "Configure required and optional employee documents",
  "hr.addEmployee": "Add employee",
  "hr.editEmployee": "Edit employee",
  "hr.searchEmployee": "Name, ID number or personnel number",
  "hr.all": "All",
  "hr.completeness": "Completeness",
  "hr.missing": "Missing",
  "hr.actions": "Actions",
  "hr.notConfigured": "Requirements not configured",
  "hr.loading": "Loading…",
  "hr.saving": "Saving…",
  "hr.uploading": "Uploading…",
  "hr.searching": "Searching…",
  "hr.linking": "Linking…",
  "hr.archiving": "Archiving…",
  "hr.retry": "Try again",
  "hr.backToEmployees": "Back to employees",
  "hr.loadError": "Could not load HR data.",
  "hr.employeeLoadError": "Could not load the employee file.",
  "hr.employeeFormLoadError":
    "Could not load the employee data required for editing.",
  "hr.refreshError":
    "The operation completed, but the employee file could not be refreshed. Try reloading the page.",
  "hr.saveError": "Could not save data.",
  "hr.uploadError": "Could not upload the document.",
  "hr.archive": "Archive",
  "hr.archiveEmployeeConfirm": "Archive this employee file?",
  "hr.archiveDocumentConfirm": "Archive this employee document?",
  "hr.archiveTypeConfirm": "Archive this document type?",
  "hr.statusActive": "Active",
  "hr.statusDismissed": "Dismissed",
  "hr.statusArchived": "Archived",
  "hr.statusService": "Service",
  "hr.surname": "Last name",
  "hr.name": "First name",
  "hr.middleName": "Middle name",
  "hr.personnelNumber": "Personnel number",
  "hr.phone": "Phone",
  "hr.esignAccount": "eSign account",
  "hr.employmentType": "Employment type",
  "hr.hireDate": "Hire date",
  "hr.dismissalDate": "Dismissal date",
  "hr.note": "Note",
  "hr.personalDocuments": "Employee documents",
  "hr.residentialAddress": "Residential address",
  "hr.notSpecified": "Not specified",
  "hr.employeeNotifications": "Employee notifications",
  "hr.requestDocumentsHint":
    "Request missing documents by email. Review the document list and message before sending.",
  "hr.recipient": "Recipient",
  "hr.emailMissingProfile": "No email address — add it to the employee profile",
  "hr.reminderLabel": "Remind the employee about expiry dates",
  "hr.reminderHint":
    "Send email reminders before documents expire and after expiry. Enabling this option does not send an email immediately.",
  "hr.enabled": "Enabled",
  "hr.disabled": "Disabled",
  "hr.notificationHistory": "Notification history",
  "hr.notificationHistoryHint":
    "The latest 5 notifications and their current status",
  "hr.refreshing": "Refreshing…",
  "hr.noNotifications": "No notifications yet.",
  "hr.notificationDate": "Date",
  "hr.notificationReason": "Reason",
  "hr.documentRequestNotification": "Document request",
  "hr.expiryReminderNotification": "Expiry reminder",
  "hr.retryDelivery": "Retry delivery",
  "hr.archiveEmployeeTitle": "Archive this employee?",
  "hr.archiveEmployeeHint": "The employee file will be moved to the archive.",
  "hr.confirmArchiveEmployee": "Yes, archive",
  "hr.employeeTypePlaceholder": "Select an employment type",
  "hr.documentValidity": "Validity period",
  "hr.documentPresence": "Availability",
  "hr.fileCount": "Files:",
  "hr.documentPresent": "Document is available",
  "hr.add": "Add",
  "hr.unclassifiedFiles": "Unclassified files",
  "hr.fileName": "File name",
  "hr.noUnclassifiedFiles": "No unclassified files",
  "hr.chooseDocumentType": "Select a type",
  "hr.currentDocument": "Current document",
  "hr.currentFile": "Current file:",
  "hr.changeDatesOnlyHint":
    "To change only the dates, do not select a new file.",
  "hr.uploadFile": "Upload file",
  "hr.fromEsign": "From eSign",
  "hr.chooseFile": "Choose a file",
  "hr.dropFile": "Drop a file here",
  "hr.clickChooseFile": "or click to choose a file",
  "hr.clearFile": "Remove selected file",
  "hr.savingFile": "Uploading and saving the file…",
  "hr.find": "Find",
  "hr.unnumberedDocument": "No number",
  "hr.replacementHint":
    "Yes, replace the existing document of this type. Previous files will be kept in the archive.",
  "hr.deleteDocumentTitle": "Delete this document?",
  "hr.deleteDocumentHint":
    "The document will be removed from the employee file and kept in the archive.",
  "hr.deleting": "Deleting…",
  "hr.confirmDeleteDocument": "Yes, delete",
  "hr.classifyDocument": "Classify document",
  "hr.addFile": "Add file",
  "hr.updateDocument": "Update document",
  "hr.addDocument": "Add document",
  "hr.document": "Document",
  "hr.kilobytes": "KB",
  "hr.megabytes": "MB",
  "hr.metadataOnly": "Only metadata is available locally",
  "hr.download": "Download",
  "hr.analytics": "HR analytics",
  "hr.analyticsMetric.employment.CONTRACT": "Employees under employment contracts",
  "hr.analyticsMetric.employment.GPH": "Employees under civil contracts",
  "hr.analyticsMetric.employees.total": "Total employees",
  "hr.analyticsMetric.field.email": "Email provided",
  "hr.analyticsMetric.field.phone": "Phone provided",
  "hr.analyticsMetric.field.iin": "IIN provided",
  "hr.analyticsMetric.field.personnelNumber": "Personnel number provided",
  "hr.analyticsMetric.field.address": "Residential address provided",
  "hr.analyticsMetric.field.job": "Job provided",
  "hr.analyticsMetric.field.hireDate": "Hire date provided",
  "hr.analyticsMetric.field.user": "Linked user account",
  "hr.analyticsMetric.docs.complete": "Required documents complete",
  "hr.analyticsMetric.docs.missing": "Missing required documents",
  "hr.analyticsMetric.docs.notConfigured": "Required checklist not configured",
  "hr.analyticsMetric.docs.withFiles": "Employees with documents",
  "hr.analyticsMetric.docs.withoutFiles": "Employees without documents",
  "hr.analyticsMetric.docs.unclassified": "Unclassified files",
  "hr.analyticsMetric.docs.expired": "Expired files",
  "hr.analyticsMetric.docs.expiring": "Files expiring within 30 days",
  "hr.analyticsConfigure": "Configure dashboard",
  "hr.analyticsHint": "Metrics cover all employees matching the filters. Dashboard configuration is shared within the tenant.",
  "hr.analyticsColumns": "Cards per row",
  "hr.analyticsMoveUp": "Move up",
  "hr.analyticsMoveDown": "Move down",
  "hr.analyticsSaveError": "Could not save dashboard settings",
  "hr.analyticsEmpty": "No metrics selected. Configure the dashboard.",
  "hr.show": "Show",
  "hr.showDocument": "Show document",
  "hr.update": "Update",
  "hr.classify": "Classify",
  "hr.invalidFileFormat": "Unsupported file format",
  "hr.chooseSingleFile": "Select one file",
  "hr.documentSearchError": "Could not search for documents",
  "hr.documentSaveError": "Could not save the document",
  "hr.documentDeleteError": "Could not delete the document",
  "hr.group.certificates": "Certificates and statements",
  "hr.group.orders": "Orders",
  "hr.group.applications": "Applications",
  "hr.group.education": "Education",
  "hr.group.other": "Other documents",
  "hr.notificationLanguage": "Notification language",
  "hr.russianLanguage": "Russian",
  "hr.englishLanguage": "English",
  "hr.selectAll": "Select all",
  "hr.deselectAll": "Deselect all",
  "hr.documentsHint": "Required and optional employee documents",
  "hr.noDocumentTypes": "Document requirements have not been configured yet.",
  "hr.required": "Required",
  "hr.documentMissing": "Document is missing",
  "hr.validUntil": "valid until",
  "hr.replace": "Replace",
  "hr.upload": "Upload",
  "hr.linkEsign": "Link from eSign",
  "hr.view": "View",
  "hr.downloadEsign": "Download eSign documents",
  "hr.downloadError": "Could not retrieve the document file",
  "hr.uploadDocument": "Upload document",
  "hr.issueDate": "Issue date",
  "hr.expiryDate": "Expiry date",
  "hr.expiryDateRequired": "Specify the document expiry date.",
  "hr.searchDocuments": "Title or registration number",
  "hr.noDocumentsFound": "No completed eSign documents were found.",
  "hr.untitledDocument": "Untitled",
  "hr.file": "File",
  "hr.addDocumentType": "Add type",
  "hr.editDocumentType": "Edit document type",
  "hr.showArchived": "Show archived",
  "hr.documentTypeName": "Document name",
  "hr.expiryRequired": "Expiry date required",
  "hr.order": "Order",
  "hr.description": "Description",
  "hr.mailSettings": "HR email notifications",
  "hr.mailSettingsHint":
    "Settings apply only to the current tenant. Enabling email delivery does not automatically email existing employees.",
  "hr.mailEnabled": "Allow HR email delivery",
  "hr.requestMissingDocuments": "Request missing documents",
  "hr.companyMailDisabledHint": "Company email delivery is disabled.",
  "hr.mailSettingsChecking": "Checking email settings…",
  "hr.contactName": "HR contact name",
  "hr.contactEmail": "HR email for submitting documents",
  "hr.contactPhone": "HR phone",
  "hr.settingsSaved": "Settings saved",
  "hr.mailSettingsLoadError": "Could not load email settings. Reload the page.",
  "hr.emailNotifications": "Email notifications",
  "hr.preparationReady": "Preparation completed",
  "hr.preparationPending": "Initial preparation not completed",
  "hr.completePreparation": "Complete preparation",
  "hr.requestDocuments": "Request documents",
  "hr.optional": "Optional, if applicable",
  "hr.mailPrivacyHint":
    "Emails contain document names and HR contacts only, with no attachments or personnel file links. Employees submit documents to HR.",
  "hr.enableExpiry": "Enable expiry reminders",
  "hr.disableExpiry": "Disable expiry reminders",
  "hr.expiryControl": "Document expiry reminders",
  "hr.expiryScheduleHint":
    "Reminders: 30, 7 and 1 day before expiry, then once after expiry. Checked daily at 09:00 Kazakhstan time. Already expired documents will also trigger a notification after enabling.",
  "hr.previewMail": "Preview",
  "hr.mailRecipientCount": "Recipients",
  "hr.emailMissing": "Email is missing",
  "hr.mailProblem.EMAIL_INVALID": "Enter a valid employee email.",
  "hr.mailProblem.EMPLOYEE_INACTIVE":
    "The employee or linked account is inactive.",
  "hr.expiredDocuments": "Expired documents",
  "hr.upcomingDocuments": "Expiring within 30 days",
  "hr.missingExpiryDates": "Required expiry date is missing",
  "hr.noDocumentsToRequest":
    "All selected documents have been uploaded. No email is needed.",
  "hr.confirmSend": "Confirm sending",
  "hr.mailActionError":
    "Could not process the notification action. Please try again.",
  "hr.notificationActionSaved":
    "Action saved. Any required emails will be processed in the background.",
  "hr.refreshDelivery": "Refresh delivery status",
  "hr.documentExpired": "Document has expired",
  "hr.documentExpiring": "Document expires soon",
  "hr.disableExpiryConfirm": "Disable expiry reminders for this employee?",
  "hr.retryMailConfirm":
    "Retry processing this notification? No new duplicate email will be created.",
  "hr.selectedEmployees": "Selected employees",
  "hr.selectEmployees": "Select active employees on this page",
  "hr.delivery.PENDING": "Waiting for the email queue",
  "hr.delivery.QUEUED": "Accepted by the email queue",
  "hr.delivery.DELIVERED": "Handed to the mail server",
  "hr.delivery.FAILED": "Transfer failed; retry scheduled",
  "hr.delivery.DEAD": "Failed — HR retry required",
  "hr.delivery.CANCELLED": "Cancelled",
  "hr.deliveryReason.MAIL_SERVICE_UNAVAILABLE":
    "Email service is temporarily unavailable.",
  "hr.deliveryReason.MAIL_STATUS_UNAVAILABLE":
    "The email queue accepted this letter. Delivery status is temporarily unavailable; it will be checked again.",
  "hr.deliveryReason.HR_RETRY_REQUESTED": "HR-requested retry is scheduled.",
  "hr.deliveryReason.SMTP_RETRY": "Retrying delivery to the mail server.",
  "hr.deliveryReason.MAIL_REQUEST_REJECTED":
    "The email service rejected the request. Check integration settings.",
  "hr.deliveryReason.SMTP_FAILED":
    "Could not deliver the email to the mail server.",
  "hr.deliveryReason.DELIVERY_DISABLED":
    "Email delivery or expiry reminders are disabled.",
  "hr.deliveryReason.EMPLOYEE_INACTIVE":
    "The employee or linked account is inactive.",
  "hr.deliveryReason.EMAIL_INVALID": "Employee email is invalid.",
  "hr.deliveryReason.EMAIL_CHANGED":
    "Employee email changed. Prepare a new request.",
  "hr.deliveryReason.DOCUMENT_CHANGED":
    "The document or reminder stage has changed.",
  "hr.deliveryReason.DOCUMENTS_COMPLETE":
    "The requested documents have already been uploaded.",
  "hr.deliveryReason.DOCUMENT_OR_RECIPIENT_CHANGED":
    "The notification is no longer applicable. Check documents, recipient and settings.",
  "permission.enbekManage": "Manage Enbek registrations",
  "enbek.tab": "Enbek",
  "enbek.register": "Register in Enbek",
  "enbek.registration": "Employment contract registration in Enbek",
  "enbek.newContract": "New employment contract",
  "enbek.employee": "Employee",
  "enbek.employer": "Employer",
  "enbek.position": "Position",
  "enbek.contractNumber": "Contract number",
  "enbek.contractDate": "Contract date",
  "enbek.beginDate": "Employment start date",
  "enbek.endDate": "End date",
  "enbek.contractTerm": "Contract term code",
  "enbek.establishedPost": "Established position",
  "enbek.establishedPostCode": "Established position code",
  "enbek.partTime": "Employment type code",
  "enbek.remoteWork": "Remote work code",
  "enbek.workPlace": "Work place",
  "enbek.workPlaceKato": "Work place KATO",
  "enbek.workPlaceCountry": "Work place country code",
  "enbek.workingHours": "Working hours code",
  "enbek.tariffRate": "Tariff rate",
  "enbek.electronicContract": "Electronic contract code",
  "enbek.externalId": "Enbek registration number",
  "enbek.period": "Period",
  "enbek.indefinite": "indefinite",
  "enbek.saveDraft": "Save draft",
  "enbek.saveAndSend": "Save and send",
  "enbek.send": "Send to Enbek",
  "enbek.saved": "Enbek draft saved",
  "enbek.saveError": "Could not save Enbek data",
  "enbek.sent": "Request sent to Enbek",
  "enbek.registered": "Contract registered in Enbek",
  "enbek.sendError": "Enbek returned an error. Details were saved in the document.",
  "enbek.noRegistrations": "This user has no Enbek registrations yet",
  "enbek.transportDisabled": "You can fill in and save the data. Sending will become available after the VPN and transport adapter are enabled.",
  "enbek.status.draft": "Draft",
  "enbek.status.sending": "Sending",
  "enbek.status.sent": "Sent",
  "enbek.status.registered": "Registered",
  "enbek.status.rejected": "Rejected",
  "enbek.status.technical_error": "Technical error",
  "hr.audit.title": "HR activity journal",
  "hr.audit.hint":
    "History of committed actions and email delivery stages. Entries appear after the operation commits; actions before the journal was introduced cannot be reconstructed.",
  "hr.audit.action": "Action",
  "hr.audit.from": "From date (UTC)",
  "hr.audit.to": "To date (UTC)",
  "hr.audit.refresh": "Refresh",
  "hr.audit.empty": "No entries match the selected filters",
  "hr.audit.date": "Action time",
  "hr.audit.actor": "Performed by",
  "hr.audit.employee": "Employee",
  "hr.audit.result": "Result",
  "hr.audit.details": "Details",
  "hr.audit.system": "System",
  "hr.audit.smtpAttempt": "SMTP attempt",
  "hr.audit.subject": "Subject",
  "hr.audit.related": "Related subject",
  "hr.audit.event": "Event ID",
  "hr.audit.operation": "Operation ID",
  "hr.audit.source": "Source",
  "hr.audit.fields": "Changed fields",
  "hr.audit.recorded": "Recorded in journal",
  "hr.audit.pages": "Journal pages",
  "hr.audit.previous": "Previous",
  "hr.audit.next": "Next",
  "hr.audit.processingError": "Processing error",
  "hr.audit.committed": "Operation committed",
  "hr.audit.invalidDates": "The start date must not be later than the end date",
  "hr.audit.loadError": "Could not load the HR journal. Please try again.",
  "hr.audit.source.BASE": "HR / base service",
  "hr.audit.source.NOTIFICATION": "Mail service",
  "hr.audit.action.EMPLOYEE_CREATED": "Employee file created",
  "hr.audit.action.EMPLOYEE_UPDATED": "Employee file updated",
  "hr.audit.action.EMPLOYEE_ARCHIVED": "Employee file archived",
  "hr.audit.action.DOCUMENT_CREATED": "Document added",
  "hr.audit.action.DOCUMENT_UPDATED": "Document updated",
  "hr.audit.action.DOCUMENT_ARCHIVED": "Document archived",
  "hr.audit.action.DOCUMENT_READ": "File retrieved for preview or download",
  "hr.audit.action.DOCUMENT_TYPE_CREATED": "Document type created",
  "hr.audit.action.DOCUMENT_TYPE_UPDATED": "Document type updated",
  "hr.audit.action.DOCUMENT_TYPE_ARCHIVED": "Document type archived",
  "hr.audit.action.EMPLOYEE_TYPE_CREATED": "Employee type created",
  "hr.audit.action.EMPLOYEE_TYPE_UPDATED": "Employee type updated",
  "hr.audit.action.EMPLOYEE_TYPE_ARCHIVED": "Employee type archived",
  "hr.audit.action.REQUIREMENT_CREATED":
    "Employee type document requirement added",
  "hr.audit.action.REQUIREMENT_UPDATED": "Document requirement updated",
  "hr.audit.action.REQUIREMENT_DELETED":
    "Employee type document requirement removed",
  "hr.audit.action.SETTINGS_CREATED": "Email settings created",
  "hr.audit.action.SETTINGS_UPDATED": "Email settings updated",
  "hr.audit.action.NOTIFICATION_CREATED": "Notification created",
  "hr.audit.action.NOTIFICATION_UPDATED": "Notification state changed",
  "hr.audit.action.MAIL_UPDATED": "Mail delivery stage",
  "hr.audit.field.user_id": "Linked user",
  "hr.audit.field.company_id": "Company",
  "hr.audit.field.job_id": "Job",
  "hr.audit.field.surname": "Surname",
  "hr.audit.field.name": "Name",
  "hr.audit.field.middle_name": "Middle name",
  "hr.audit.field.full_name": "Full name",
  "hr.audit.field.iin": "Individual identification number",
  "hr.audit.field.personnel_number": "Personnel number",
  "hr.audit.field.email": "Email",
  "hr.audit.field.phone": "Phone",
  "hr.audit.field.employment_type": "Employment type",
  "hr.audit.field.employee_type_id": "Employee type",
  "hr.audit.field.hire_date": "Hire date",
  "hr.audit.field.dismissal_date": "Dismissal date",
  "hr.audit.field.note": "Note",
  "hr.audit.field.status": "Status",
  "hr.audit.field.preparation_completed": "Employee file preparation completed",
  "hr.audit.field.expiry_notifications_enabled": "Expiry reminders",
  "hr.audit.field.employee_id": "Employee",
  "hr.audit.field.document_type_id": "Document type",
  "hr.audit.field.source": "Document source",
  "hr.audit.field.file_guid": "File reference",
  "hr.audit.field.esign_document_id": "eSign document reference",
  "hr.audit.field.issue_date": "Issue date",
  "hr.audit.field.expiry_date": "Expiry date",
  "hr.audit.field.created_by": "Added by",
  "hr.audit.field.archived_at": "Archive time",
  "hr.audit.field.description": "Description",
  "hr.audit.field.is_required": "Required",
  "hr.audit.field.requires_expiry_date": "Expiry date required",
  "hr.audit.field.allows_esign_link": "eSign linking allowed",
  "hr.audit.field.sort_order": "Order",
  "hr.audit.field.code": "Type code",
  "hr.audit.field.enabled": "Email delivery enabled",
  "hr.audit.field.contact_name": "HR contact name",
  "hr.audit.field.contact_email": "HR contact email",
  "hr.audit.field.contact_phone": "HR contact phone",
  "hr.audit.field.notification_id": "Notification ID",
  "hr.audit.field.notification_key": "Notification operation key",
  "hr.audit.field.type": "Notification type",
  "hr.audit.field.document_type_ids": "Document checklist",
  "hr.audit.field.document_id": "Document",
  "hr.audit.field.reminder_days": "Reminder stage",
  "hr.audit.field.initiated_by": "Initiator",
  "hr.audit.field.recipient": "Recipient",
  "hr.audit.field.attempts": "Attempt count",
  "hr.audit.field.reason_code": "Reason",
  "hr.audit.field.accepted_at": "Queue acceptance time",
  "hr.audit.field.delivered_at": "SMTP acceptance time",
  "hr.audit.field.original_file_name": "Original file name",
  "hr.audit.field.source_path": "Import source",
  "hr.audit.field.original_file_size": "File size",
  "hr.audit.field.original_content_type": "File type",
  "hr.audit.field.classification_confidence": "Classification confidence",
  "hr.audit.field.proposed_document_type_name": "Suggested document type",
  "hr.audit.field.external_file": "Imported file",
  "hr.audit.mail.PENDING": "Email queued for SMTP",
  "hr.audit.mail.FAILED": "SMTP transfer failed",
  "hr.audit.mail.DEAD": "Delivery failed — HR action required",
  "hr.audit.mail.DELIVERED": "Email accepted by the SMTP server",
  "hr.audit.mail.CANCELLED": "Delivery cancelled",
};
